import { render, staticRenderFns } from "./karenydaniel.vue?vue&type=template&id=e5f15618&"
import script from "./karenydaniel.vue?vue&type=script&lang=js&"
export * from "./karenydaniel.vue?vue&type=script&lang=js&"
import style0 from "./karenydaniel.vue?vue&type=style&index=0&id=e5f15618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports